import { HttpClient } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, makeStateKey, Optional, PLATFORM_ID, REQUEST, REQUEST_CONTEXT, TransferState } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { RestService } from "../rest/rest.service";
import { ConfigGlobalModel } from "app/models/config-global-model";
import { environment } from 'environments/environment';
import { IS_DISCOVERING_ROUTES } from '@angular/ssr';

const CONFIG_STATE_KEY = makeStateKey<ConfigGlobalModel>('app-config');

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: any;

  constructor(
    private restService: RestService,
    private http: HttpClient,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object,
    @Optional() @Inject(REQUEST) private request: Request | null,
    @Optional() @Inject(REQUEST_CONTEXT) private requestContext: { configuration?: ConfigGlobalModel } | null,
    @Optional() @Inject(IS_DISCOVERING_ROUTES) private discoveringRoutes: boolean | null
  ) { }

  loadConfig(): Promise<ConfigGlobalModel> {
    if (this.transferState.hasKey(CONFIG_STATE_KEY)) {
      this.config = this.transferState.get(CONFIG_STATE_KEY, null);
      this.transferState.remove(CONFIG_STATE_KEY);
      return Promise.resolve(this.config);
    }

    if (isPlatformServer(this.platformId)) {
      if (this.discoveringRoutes) {
        return Promise.resolve(null);
      }

      if (this.requestContext?.configuration) {
        this.config = this.requestContext.configuration;
        this.transferState.set(CONFIG_STATE_KEY, this.config);
        return Promise.resolve(this.config);
      }

      if (!this.request) {
        return Promise.reject(new Error('SSR necesita una URL de petición para cargar la configuración.'));
      }

      const url = new URL(`${environment.urlServer}/public/configuration`, this.request.url).toString();
      return firstValueFrom(this.http.get<ConfigGlobalModel>(url)).then(data => {
        this.config = data;
        this.transferState.set(CONFIG_STATE_KEY, data);
        return data;
      });
    }

    return firstValueFrom(this.restService.getConfigurationGlobal()).then(data => this.config = data);
  }

  get settings():ConfigGlobalModel { return this.config; }
}
